import { useState } from 'react';
import { api } from '../api';

export function SignIn() {
  const [email, setEmail] = useState('');
  const [accountType, setAccountType] = useState<'residential' | 'commercial'>('residential');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  if (sent) {
    return <p className="hint">Check {email} for a sign-in link. It works once and expires in 15 minutes.</p>;
  }

  return (
    <form
      className="sign-in"
      onSubmit={async (e) => {
        e.preventDefault();
        setBusy(true);
        setErr('');
        try {
          await api.postJson('/auth/request-link', { email, account_type: accountType });
          setSent(true);
        } catch {
          setErr('Something went wrong. Please try again.');
        } finally {
          setBusy(false);
        }
      }}
    >
      <label htmlFor="signin-email">Email</label>
      <input id="signin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
      <fieldset>
        <legend>If this is your first time signing in, which are you?</legend>
        <label className="check">
          <input type="radio" name="account_type" checked={accountType === 'residential'} onChange={() => setAccountType('residential')} />
          An individual, listing my own sale(s)
        </label>
        <label className="check">
          <input type="radio" name="account_type" checked={accountType === 'commercial'} onChange={() => setAccountType('commercial')} />
          A business or organization (estate sale company, auction house, festival, etc.)
        </label>
      </fieldset>
      <p className="hint">This only matters if you ever pay to feature a listing — it decides your price. Existing accounts keep what they already have.</p>
      {err && (
        <p className="error" role="alert">
          {err}
        </p>
      )}
      <button className="primary" type="submit" disabled={busy || !email}>
        Send me a sign-in link
      </button>
    </form>
  );
}
